module.exports = __webpack_public_path__ + "static/media/expand-circle.d2a839c9.svg";